import React ,{useEffect}from "react";
import {Grid} from '@material-ui/core';
import { CardAbm } from "../../abm/CardAbm";
import { useSelector,useDispatch } from "react-redux";
import { fetchMotivosBajaTurno } from "../../../../actions/turnos/motivosBajaTurno";
import { MOTIVOSBAJATURNOS_PERMISOS } from "../../../../utils/permisos";

export const HomeMotivosBajaTurnos = () => {
  const {items} = useSelector((state)=>state.motivosBajaTurno);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch( fetchMotivosBajaTurno() );
  }, [dispatch]);

  return (
    <Grid item lg={12}> 
        <CardAbm 
          id={'idMotivosBajaTurnos'}
          lista={items} 
          titulo={"Motivos Baja Turnos"}
          permisoAdd={MOTIVOSBAJATURNOS_PERMISOS.ALTA}
          permisoEdit={MOTIVOSBAJATURNOS_PERMISOS.MODIFICACION}
          permisoDelete={MOTIVOSBAJATURNOS_PERMISOS.BAJA}
        />
    </Grid>
  );

};
